import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reservation-actions" }

import { request } from '@/admin/shared/api/httpClient';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReservationActions',
  props: {
    detail: {}
  },
  setup(__props: any) {

const props = __props;

const reservationId = (): string => String(props.detail.id);

async function cancelReservation(): Promise<void> {
    if (!confirm('Отменить резервирование?')) return;
    await request({
        method: 'post',
        url: `/admin-api/reservations/${reservationId()}/cancel/`,
        data: {},
    });
    window.location.reload();
}

async function extendReservation(): Promise<void> {
    if (!confirm('Продлить резерв на 15 минут?')) return;
    await request({
        method: 'post',
        url: `/admin-api/reservations/${reservationId()}/extend/`,
        data: { minutes: 15 },
    });
    window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn--danger",
      onClick: cancelReservation
    }, "Отменить резерв"),
    _createElementVNode("button", {
      class: "btn",
      onClick: extendReservation
    }, "Продлить (+15 мин)")
  ]))
}
}

})